/**
 * Section 91 max capital-gain tax rate by taxpayer type and sale year (Hisulit-aligned V1 config).
 * Replace with backend tax settings when available.
 */

export const CAPITAL_GAIN_MAX_TAX_BY_YEAR = {
    company: {
        2026: { rate: 23, section: '91(א)' },
        2011: { rate: 24, section: '91(א)' },
    },
    individual: {
        2011: { rate: 45, section: '91(ב)' },
        2026: { rate: 47, section: '91(ב)' },
    },
};

export const DEFAULT_CAPITAL_GAIN_MAX_TAX = {
    company: { rate: 23, section: '91(א)' },
    individual: { rate: 47, section: '91(ב)' },
};

/** @deprecated use getMaxCapitalGainTaxConfig */
export const DEFAULT_MAX_SECTION_91_RATE = DEFAULT_CAPITAL_GAIN_MAX_TAX.individual.rate;

/** @deprecated use getMaxCapitalGainTaxConfig */
export const MAX_TAX_RATE_BY_YEAR = {
    2011: CAPITAL_GAIN_MAX_TAX_BY_YEAR.individual[2011].rate,
    2026: CAPITAL_GAIN_MAX_TAX_BY_YEAR.individual[2026].rate,
};

const COMPANY_CASE_TYPES = new Set(['חברה', 'בע"מ', 'בע״מ']);

/**
 * @param {string|null|undefined} caseType
 * @returns {'company'|'individual'}
 */
export function getCapitalGainTaxpayerType(caseType) {
    const normalized = (caseType || '').toString().trim();
    if (COMPANY_CASE_TYPES.has(normalized)) return 'company';
    return 'individual';
}

/**
 * @param {number|string|null|undefined} saleYear
 * @param {string|null|undefined} caseType
 * @returns {{ rate: number, section: string }}
 */
export function getMaxCapitalGainTaxConfig(saleYear, caseType) {
    const taxpayerType = getCapitalGainTaxpayerType(caseType);
    const year = saleYear != null ? Number(saleYear) : null;
    const byYear = CAPITAL_GAIN_MAX_TAX_BY_YEAR[taxpayerType];

    if (year != null && !Number.isNaN(year) && byYear?.[year]) {
        return byYear[year];
    }

    return DEFAULT_CAPITAL_GAIN_MAX_TAX[taxpayerType];
}

/** @deprecated use getMaxCapitalGainTaxConfig */
export function getMaxSection91RateForSaleYear(saleYear, caseType) {
    return getMaxCapitalGainTaxConfig(saleYear, caseType).rate;
}

/** Clamp editable tax rate inputs to [0, maxRate]. */
export function normalizeTaxRate(value, maxRate) {
    const num = Number(value || 0);
    if (Number.isNaN(num)) return 0;
    return Math.min(Math.max(num, 0), maxRate);
}
